import { SVGProps } from "react";

export const ModalSuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="52" height="53" viewBox="0 0 52 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1.5" width="50" height="50" rx="25" stroke="#2EB8C5" stroke-width="2"/>
    <path d="M18 25.9994L23.7676 31.9286L34 20.5" stroke="#2EB8C5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
